import { FunctionComponent, useMemo, type CSSProperties } from "react";
import styles from "./FRAME1.module.css";

export type FRAME1Type = {
  image59?: string;
  drEricSMaskin?: string;
  ericMaskinIsTheAdamsUnive?: string;

  /** Style props */
  propHeight?: CSSProperties["height"];
};

const FRAME1: FunctionComponent<FRAME1Type> = ({
  image59,
  drEricSMaskin,
  ericMaskinIsTheAdamsUnive,
  propHeight,
}) => {
  const drEricSStyle: CSSProperties = useMemo(() => {
    return {
      height: propHeight,
    };
  }, [propHeight]);

  return (
    <div className={styles.fRAME}>
      <img
        className={styles.image59Icon}
        loading="eager"
        alt=""
        src={image59}
      />
      <div className={styles.fRAME1}>
        <h2 className={styles.drEricS} style={drEricSStyle}>
          {drEricSMaskin}
        </h2>
        <div className={styles.ericMaskinIs}>{ericMaskinIsTheAdamsUnive}</div>
      </div>
    </div>
  );
};

export default FRAME1;
